import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutMobileCommControlZmit } from "./autogen/AutogenLayoutMobileCommControlZmit";

export class MobileCommControlZmit extends AutogenLayoutMobileCommControlZmit {

    async onLoad() {
    }

    textboxDispatchFormBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.form_type = "O";

        if (this.mainDataSource?.activeRow.get("id")) {
            event.filter.mc_control_id = this.mainDataSource.activeRow.get("id");
        }
    }
}
